var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-2",
    transform: "translate(0 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435_18",
    "data-name": "\\u0412\\u044B\\u0447\\u0438\\u0442\\u0430\\u043D\\u0438\\u0435 18",
    d: "M28,56A28.007,28.007,0,0,1,17.1,2.2,28,28,0,0,1,47.8,47.8,27.909,27.909,0,0,1,28,56ZM24.478,27.954V41.946H29.75V27.954h4.325l.832-5.222H29.755V21.127a1.721,1.721,0,0,1,1.654-1.85h3.609V13.946H30.773v.021c-2.366.084-4.014.732-5.035,1.982a6.577,6.577,0,0,0-1.251,4.122v0l-.009,0v2.661h-3.5v5.222Z",
    transform: "translate(0 -0.2)",
    fill: "#4267b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.1c98cd1f43b1a7790ae77cadad562a0e.svg";
export { ForwardRef as ReactComponent };